import api from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}


export const getCheckAllTS = async () => {
    let rst = false;
    try {
        const response = await api.get(`Timesheet/check-all-ts`, config);
        rst = response?.data?.data ?? false;
    } catch (err) {
        return false;
    }
    return rst;
}



export const getExportarTimesheet = async () => {
    let rst = false;
    try {
        const response = await api.get(`Timesheet/check-exportar`, config);
        rst = response?.data?.data ?? false;
    } catch (err) {
        return false;
    }
    return rst;
}